export const din276_08 = {
  year: 2008,
  data: [
    {
      number: '100',
      label: 'Grundstück',
      description: '',
      phases: [
        {
          number: '110',
          label: 'Grundstückswert',
          description: '',
        },
        {
          number: '120',
          label: 'Grundstücksnebenkosten',
          description:
            'Kosten, die im Zusammenhang mit dem Erwerb eines Grundstücks entstehen',
          phases: [
            {
              number: '121',
              label: 'Vermessungsgebühren',
              description: '',
            },

            {
              number: '122',
              label: 'Gerichtsgebühren',
              description: '',
            },
            {
              number: '123',
              label: 'Notargebühren',
              description: '',
            },
            {
              number: '124',
              label: 'Maklerprovisionen',
              description: '',
            },
            {
              number: '125',
              label: 'Grunderwerbssteuer',
              description: '',
            },
            {
              number: '126',
              label: 'Wertermittlungen, Untersuchungen',
              description:
                'Wertermittlungen, Untersuchungen zu Altlasten und deren Beseitigung, Baugrunduntersuchungen und Untersuchungen über die Bebaubarkeit, soweit sie zur Beurteilung des Grundstückwertes dienen',
            },
            {
              number: '127',
              label: 'Genehmigungsgebühren',
              description: '',
            },
            {
              number: '128',
              label: 'Bodenordnung, Grenzregulierung',
              description: '',
            },
            {
              number: '129',
              label: 'Grundstücksnebenkosten, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '130',
          label: 'Freimachen',
          description:
            'Kosten, die aufzuwenden sind, um ein Grundstück von Belastung freizumachen',
          phases: [
            {
              number: '131',
              label: 'Abfindungen',
              description:
                'Abfindungen und Entschädigungen für bestehende Nutzungsrechte (z. B. Miet- und Pachtverträge)',
            },
            {
              number: '132',
              label: 'Ablösen dinglicher Rechte',
              description:
                'Ablösen von Lasten und Beschränkungen z. B. Wegerechten',
            },

            {
              number: '139',
              label: 'Freimachen, sonstiges',
              description: '',
            },
          ],
        },
      ],
    },

    {
      number: '200',
      label: 'Herrichten und Erschließen',
      description:
        'Kosten aller vorbereitenden Maßnahmen, um die Baumaßnahme auf dem Grundstück durchführen zu können',
      phases: [
        {
          number: '210',
          label: 'Herrichten',
          description:
            'Kosten der vorbereitenden Maßnahmen, soweit nicht in anderen Kostengruppen erfasst',
          phases: [
            {
              number: '211',
              label: 'Sicherungsmaßnahmen',
              description:
                'Schutz von vorhandenen Bauwerken, Bauteilen, Versorgungsleitungen sowie Sichern von Bewuchs und Vegetationsschichten',
            },
            {
              number: '212',
              label: 'Abbruchmaßnahmen',
              description:
                'Abbrechen und Beseitigen von vorhandenen Bauwerken, Ver- und Entsorgungsleitungen sowie Verkehrsanlagen',
            },
            {
              number: '213',
              label: 'Altlastenbeseitigung',
              description:
                'Beseitigen von Kampfmitteln und anderen gefährlichen Stoffen, Sanieren belasteter und kontaminierter Böden',
            },
            {
              number: '214',
              label: 'Herrichten der Geländeoberfläche',
              description:
                'Roden von Bewuchs, Planieren, Bodenbewegungen einschließlich Oberbodensicherung, soweit nicht in KG 500 erfasst',
            },
            {
              number: '219',
              label: 'Herrichten, sonstiges',
              description: '',
            },
          ],
        },

        {
          number: '220',
          label: 'Öffentliche Erschließung',
          description:
            'Anteilige Kosten aufgrund gesetzlicher Vorschriften (Erschließungsbeiträge/Anliegerbeiträge) und Kosten aufgrund öffentlich-rechtlicher Verträge für - die Beschaffung oder den Erwerb der Erschließungsflächen gegen Entgelt durch den Träger der öffentlichen Erschließung, - die Herstellung oder Änderung gemeinschaftlich genutzter technischer Anlagen, z. B. zur Ableitung von Abwasser sowie zur Versorgung mit Wasser, Wärme, Gas, Strom und Telekommunikation, - die erstmalige Herstellung oder den Ausbau der öffentlichen Verkehrsflächen, der Grünflächen und sonstiger Freiflächen für öffentliche Nutzung. Kostenzuschüsse und Anschlusskosten sollen getrennt ausgewiesen werden.',
          phases: [
            {
              number: '221',
              label: 'Abwasserentsorgung',
              description: 'Kostenzuschüsse, Anschlusskosten',
            },
            {
              number: '222',
              label: 'Wasserversorgung',
              description: 'Kostenzuschüsse, Anschlusskosten',
            },
            {
              number: '223',
              label: 'Gasversorgung',
              description: 'Kostenzuschüsse, Anschlusskosten',
            },
            {
              number: '224',
              label: 'Fernwärmeversorgung',
              description: 'Kostenzuschüsse, Anschlusskosten',
            },

            {
              number: '225',
              label: 'Stromversorgung',
              description: 'Kostenzuschüsse, Anschlusskosten',
            },
            {
              number: '226',
              label: 'Telekommunikation',
              description:
                'Einmalige Entgelte für die Bereitstellung und Änderung von Netzanschlüssen',
            },
            {
              number: '227',
              label: 'Verkehrserschließung',
              description:
                'Erschließungsbeiträge für die Verkehrs- und Freianlagen einschließlich deren Entwässerung und Beleuchtung',
            },
            {
              number: '228',
              label: 'Abfallentsorgung',
              description:
                'Kostenzuschüsse, Anschlusskosten z. B. für eine leitungsgebundene Abfallentsorgung',
            },
            {
              number: '229',
              label: 'Öffentliche Erschließung, sonstiges',
              description: '',
            },
          ],
        },

        {
          number: '230',
          label: 'Nichtöffentliche Erschließung',
          description:
            'Kosten für Verkehrsflächen und technische Anlagen, die ohne öffentlich-rechtliche Verpflichtung oder Beauftragung mit dem Ziel der späteren Übertragung in den Gebrauch der Allgemeinheit hergestellt und ergänzt werden. Kosten von Anlagen auf dem eigenen Grundstück gehören zu der Kostengruppe 500. Soweit erforderlich, kann die Kostengruppe 230 entsprechend der Kostengruppe 220 untergliedert werden.',
        },
        {
          number: '240',
          label: 'Ausgleichsabgaben',
          description:
            'Kosten, die aufgrund rechtlicher Bestimmungen aus Anlass des geplanten Bauvorhabens einmalig und zusätzlich zu den Erschließungbeiträgen entstehen. Hierzu gehört insbesondere das Ablösen von Verpflichtungen aus öffentlich-rechtlichen Vorschriften, z. B. Stellplätze, Baumbestand.',
        },
        {
          number: '250',
          label: 'Übergangsmaßnahmen',
          description: '',
          phases: [
            {
              number: '251',
              label: 'Provisorien',
              description:
                'Kosten der Erstellung, Anpassung oder Umlegung von Bauwerken und Außenanlagen als provisorische Maßnahme der endgültigen Bauwerke und Außenanlagen einschließlich dem Wiederentfernen der Provisorien soweit nicht in den Kostengruppen 398, 498 und 598 erfasst.',
            },
            {
              number: '252',
              label: 'Auslagerungen',
              description:
                'Kosten für die Auslagerung von Nutzungen während der Bauzeit',
            },
          ],
        },
      ],
    },

    {
      number: '300',
      label: 'Bauwerk - Baukonstruktionen',
      description:
        'Kosten von Bauleistungen und Lieferungen zur Herstellung des Bauwerks, jedoch ohne die Technischen Anlagen (Kostengruppe 400). Dazu gehören auch die mit dem Bauwerk fest verbundenen Einbauten, die der besonderen Zweckbestimmung dienen, sowie übergreifende Maßnahmen in Zusammenhang mit den Baukonstruktionen. Bei Umbauten und Modernisierungen zählen hierzu auch die Kosten von Teilabbruch-, Instandsetzungs-, Sicherungs- und Demontagearbeiten. Die Kosten sind bei den betreffenden Kostengruppen auszuweisen.',
      phases: [
        {
          number: '310',
          label: 'Baugrube',
          description: '',
          phases: [
            {
              number: '311',
              label: 'Baugrubenherstellung',
              description:
                'Bodenabtrag, Aushub einschließlich Arbeitsräumen und Böschungen, Lagern, Hinterfüllen, Ab- und Anfuhr',
            },
            {
              number: '312',
              label: 'Baugrubenumschließung',
              description:
                'Verbau, z. B. Schlitz-, Pfahl-, Spund-, Trägerbohl-, Injektions- und Spritzbetonwände einschließlich Verankerung, Absteifung',
            },
            {
              number: '313',
              label: 'Wasserhaltung',
              description:
                'Grund- und Schichtenwasserbeseitigung während der Bauzeit',
            },
            {
              number: '319',
              label: 'Baugrube, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '320',
          label: 'Gründung',
          description:
            'Die Kostengruppen enthalten die zugehörigen Erdarbeiten und Sauberkeitsschichten.',
          phases: [
            {
              number: '321',
              label: 'Baugrundverbesserung',
              description: 'Bodenaustausch, Verdichtung, Einpressung',
            },
            {
              number: '322',
              label: 'Flachgründungen',
              description: 'Einzel-, Streifenfundamente, Fundamentplatten',
            },
            {
              number: '323',
              label: 'Tiefgründungen',
              description:
                'Pfahlgründung einschließlich Roste, Brunnengründungen; Verankerungen',
            },
            {
              number: '324',
              label: 'Unterböden und Bodenplatten',
              description:
                'Unterböden und Bodenplatten, die nicht der Fundamentierung dienen',
            },

            {
              number: '325',
              label: 'Bodenbeläge',
              description:
                'Beläge auf Boden- und Fundamentplatten, z. B. Estriche, Dichtungs-, Dämm-, Schutz-, Nutzschichten',
            },
            {
              number: '326',
              label: 'Bauwerksabdichtungen',
              description:
                'Abdichtungen des Bauwerks einschließlich Filter-, Trenn- und Schutzschichten',
            },
            {
              number: '327',
              label: 'Dränagen',
              description: 'Leitungen, Schächte, Packungen',
            },
            { number: '329', label: 'Gründung, sonstiges', description: '' },
          ],
        },
        {
          number: '330',
          label: 'Außenwände',
          description:
            'Wände und Stützen, die dem Außenklima ausgesetzt sind bzw. an das Erdreich oder an andere Bauwerke grenzen',
          phases: [
            {
              number: '331',
              label: 'Tragende Außenwände',
              description:
                'Tragende Außenwände einschließlich horizontaler Abdichtungen',
            },
            {
              number: '332',
              label: 'Nichttragende Außenwände',
              description:
                'Außenwände, Brüstungen, Ausfachungen, jedoch ohne Bekleidungen',
            },
            {
              number: '333',
              label: 'Außenstützen',
              description:
                'Stützen und Pfeiler mit einem Querschnittsverhältnis ≤ 1 : 5',
            },
            {
              number: '334',
              label: 'Außentüren und -fenster ',
              description:
                'Fenster und Schaufenster, Türen und Tore einschließlich Fensterbänken, Umrahmungen, Beschlägen, Antrieben, Lüftungselementen und sonstigen eingebauten Elementen',
            },
            {
              number: '335',
              label: 'Außenwandbekleidungen, außen',
              description:
                'Äußere Bekleidungen einschließlich Putz-, Dichtungs-, Dämm-, Schutzschichten an Außenwänden und -stützen',
            },
            {
              number: '336',
              label: 'Außenwandbekleidungen, innen',
              description:
                'Raumseitige Bekleidungen, einschließlich Putz-, Dichtungs-, Dämm-, Schutzschichten an Außenwänden und -stützen',
            },
            {
              number: '337',
              label: 'Elementierte Außenwände',
              description:
                'Elementierte Wände, bestehend aus Außenwand, -fenster, -türen, -bekleidungen',
            },
            {
              number: '338',
              label: 'Sonnenschutz',
              description:
                'Rollläden, Markisen und Jalousien einschließlich Antrieben',
            },
            {
              number: '339',
              label: 'Außenwände, sonstiges',
              description: 'Gitter, Geländer, Stoßabweiser und Handläufe',
            },
          ],
        },
        {
          number: '340',
          label: 'Innenwände',
          description: 'Innenwände und Innenstützen',
          phases: [
            {
              number: '341',
              label: 'Tragende Innenwände',
              description:
                'Tragende Innenwände einschließlich horizontaler Abdichtungen',
            },

            {
              number: '342',
              label: 'Nichttragende Innenwände',
              description: 'Innenwände, Ausfachungen, jedoch ohne Bekleidungen',
            },
            {
              number: '343',
              label: 'Innenstützen',
              description:
                'Stützen und Pfeiler mit einem Querschnittsverhältnis < 1 : 5',
            },
            {
              number: '344',
              label: 'Innentüren und -fenster',
              description:
                'Türen und Tore, Fenster und Schaufenster einschließlich Umrahmungen, Beschlägen, Antrieben und sonstigen eingebauten Elementen',
            },
            {
              number: '345',
              label: 'Innenwandbekleidungen',
              description:
                'Bekleidungen einschließlich Putz, Dichtungs-, Dämm-, Schutzschichten an Innenwänden und -stützen',
            },
            {
              number: '346',
              label: 'Elementierte Innenwände',
              description:
                'Elementierte Wände, bestehend aus Innenwänden, -türen, -fenstern, -bekleidungen, z. B. Falt- und Schiebewände, Sanitärtrennwände, Verschläge',
            },
            {
              number: '349',
              label: 'Innenwände, sonstiges',
              description:
                'Gitter, Geländer, Stoßabweiser, Handläufe, Rollläden einschließlich Antrieben',
            },
          ],
        },

        {
          number: '350',
          label: 'Decken',
          description:
            'Decken, Treppen und Rampen oberhalb der Gründung und unterhalb der Dachfläche',
          phases: [
            {
              number: '351',
              label: 'Deckenkonstruktionen',
              description:
                'Konstruktionen von Decken, Treppen, Rampen, Balkonen, Loggien einschließlich Über- und Unterstützen, füllenden Teilen wie Hohlkörpern, Blindböden, Schüttungen, jedoch ohne Beläge und Bekleidungen',
            },
            {
              number: '352',
              label: 'Deckenbeläge',
              description:
                'Beläge auf Deckenkonstruktionen einschließlich Estrichen, Dichtungs-, Dämm-, Schutz-, Nutzschichten; Schwing- und Installationsdoppelböden',
            },
            {
              number: '353',
              label: 'Deckenbekleidungen',
              description:
                'Bekleidungen unter Deckenkonstruktionen einschließlich Putz, Dichtungs-, Dämm-, Schutzschichten; Licht- und Kombinationsdecken',
            },
            {
              number: '359',
              label: 'Decken, sonstiges',
              description:
                'Abdeckungen, Schachtdeckel, Roste, Geländer, Stoßabweiser, Handläufe, Leitern, Einschubtreppen',
            },
          ],
        },

        {
          number: '360',
          label: 'Dächer',
          description: 'Flache oder geneigte Dächer',
          phases: [
            {
              number: '361',
              label: 'Dachkonstruktionen',
              description:
                'Konstruktionen von Dächern, Dachstühlen, Raumtragwerken und Kuppeln einschließlich Über- und Unterzügen, füllenden Teilen wie Hohlkörpern, Blindböden, Schüttungen, jedoch ohne Beläge und Bekleidungen',
            },
            {
              number: '362',
              label: 'Dachfenster, Dachöffnungen',
              description:
                'Fenster, Ausstiege einschließlich Umrahmungen, Beschlägen, Antrieben, Lüftungselementen und sonstigen eingebauten Elementen',
            },
            {
              number: '363',
              label: 'Dachbeläge',
              description:
                'Beläge auf Dachkonstruktionen einschließlich Schalungen, Lattungen, Gefälle-, Dichtungs-, Dämm-, Schutz- und Nutzschichten; Entwässerungen der Dachfläche bis zum Anschluss an die Abwasseranlagen',
            },
            {
              number: '364',
              label: 'Dachbekleidungen',
              description:
                'Dachbekleidungen unter Dachkonstruktionen einschließlich Putz, Dichtungs-, Dämm-, Schutzschichten; Licht- und Kombinationsdecken unter Dächern',
            },
            {
              number: '369',
              label: 'Dächer, sonstiges',
              description:
                'Geländer, Laufbohlen, Schutzgitter, Schneefänge, Dachleitern, Sonnenschutz',
            },
          ],
        },
        {
          number: '370',
          label: 'Baukonstruktive Einbauten',
          description:
            'Kosten der mit dem Bauwerk fest verbundenen Einbauten, jedoch ohne die nutzungsspezifischen Anlagen (siehe Kostengruppe 470). Für die Abgrenzung gegenüber der Kostengruppe 610 ist maßgebend, dass die Einbauten durch ihre Beschaffenheit und Befestigung technische und bauplanerische Maßnahmen erforderlich machen, z. B. Anfertigen von Werkplänen, statischen und anderen Berechnungen, Anschließen von Installationen',
          phases: [
            {
              number: '371',
              label: 'Allgemeine Einbauten',
              description:
                'Einbauten, die einer allgemeinen Zweckbestimmung dienen, z. B. Einbaumöbel wie Sitz- und Liegemöbel, Gestühl, Podien, Tische, Theken, Schränke, Garderoben, Regale, Einbauküche',
            },
            {
              number: '372',
              label: 'Besondere Einbauten',
              description:
                'Einbauten, die einer besonderen Zweckbestimmung eines Objektes dienen, z. B. Werkbänke in Werkhallen, Labortische in Labors, Bühnenvorhänge in Theatern, Altäre in Kirchen, Einbausportgeräte in Sporthallen, Operationstische in Krankenhäusern',
            },
            {
              number: '379',
              label: 'Baukonstruktive Einbauten, sonstiges',
              description: 'z. B. Rauchschutzvorhänge',
            },
          ],
        },
        {
          number: '390',
          label: 'Sonstige Maßnahmen für Baukonstruktionen',
          description:
            'Baukonstruktionen und übergreifende Maßnahmen im Zusammenhang mit den Baukonstruktionen, die nicht einzelnen Kostengruppen der Baukonstruktionen zugeordnet werden können oder die nicht unter KG 490 oder KG 590 erfasst sind',
          phases: [
            {
              number: '391',
              label: 'Baustelleneinrichtung',
              description:
                'Einrichten, Vorhalten, Betreiben, Räumen der übergeordneten Baustelleneinrichtung, z. B. Material- und Geräteschuppen, Lager-, Wasch-, Toiletten- und Aufenthaltsräume, Bauwagen, Misch- und Transportanlagen, Energie- und Bauwasseranschlüsse, Baustraßen, Lager- und Arbeitsplätze, Verkehrssicherungen, Abdeckungen, Bauschilder, Bau- und Schutzzäune, Baubeleuchtung, Schuttbeseitigung',
            },
            {
              number: '392',
              label: 'Gerüste',
              description: 'Auf-, Um-, Abbauen, Vorhalten von Gerüsten',
            },
            {
              number: '393',
              label: 'Sicherungsmaßnahmen',
              description:
                'Sicherungsmaßnahmen an bestehenden Bauwerken, z. B. Unterfangungen, Abstützungen',
            },
            {
              number: '394',
              label: 'Abbruchmaßnahmen',
              description:
                'Abbruch- und Demontagearbeiten einschließlich Zwischenlagern wiederverwendbarer Teile, Abfuhr des Abbruchmaterials, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '395',
              label: 'Instandsetzungen',
              description:
                'Maßnahmen zur Wiederherstellung des zum bestimmungsgemäßen Gebrauch geeigneten Zustandes, soweit nicht in anderen Kostengruppen erfassbar',
            },
            {
              number: '396',
              label: 'Materialentsorgung',
              description:
                'Entsorgung von Materialien und Stoffen, die bei dem Abbruch, bei der Demontage und bei dem Ausbau von Bauteilen oder bei der Erstellung einer Bauleistung anfallen zum Zweck des Recyclings oder der Deponierung',
            },
            {
              number: '397',
              label: 'Zusätzliche Maßnahmen',
              description:
                'Zusätzliche Maßnahmen bei der Erstellung von Baukonstruktionen z. B. Schutz von Personen, Sachen; Reinigung vor Inbetriebnahme; Maßnahmen aufgrund von Forderungen des Wasser-, Landschafts-, Lärm- und Erschütterungsschutzes während der Bauzeit; Schlechtwetter und Winterbauschutz, Erwärmung des Bauwerks, Schneeräumung',
            },
            {
              number: '398',
              label: 'Provisorische Baukonstruktionen',
              description:
                'Kosten für die Erstellung, Beseitigung provisorischer Baukonstruktionen, Anpassung des Bauwerks bis zur Inbetriebnahme des endgültigen Bauwerks',
            },

            {
              number: '399',
              label: 'Sonstige Maßnahmen für Baukonstruktionen, sonstiges',
              description:
                'Baukonstruktionen, die mehrere Kostengruppen betreffen, z. B. Schließanlagen, Schächte, Schornsteine, soweit nicht in anderen Kostengruppen erfasst',
            },
          ],
        },
      ],
    },

    {
      number: '400',
      label: 'Bauwerk - Technische Anlagen',
      description:
        'Kosten aller im Bauwerk eingebauten, daran angeschlossenen oder damit fest verbundenen technischen Anlagen oder Anlagenteile Die einzelnen technischen Anlagen enthalten die zugehörigen Gestelle, Befestigungen, Armaturen, Wärme- und Kältedämmung, Schall- und Brandschutzvorkehrungen, Abdeckungen, Verkleidungen, Anstriche, Kennzeichnungen sowie die anlagenspezifischen Mess-, Steuer- und Regelanlagen. Die Kosten für das Erstellen und Schließen von Schlitzen und Durchführungen werden in der Regel in der KG 300 erfasst.',
      phases: [
        {
          number: '410',
          label: 'Abwasser-, Wasser-, Gasanlagen',
          description: '',
          phases: [
            {
              number: '411',
              label: 'Abwasseranlagen',
              description:
                'Abläufe, Abwasserleitungen, Abwassersammelanlagen, Abwasserbehandlungsanlagen, Hebeanlagen',
            },
            {
              number: '412',
              label: 'Wasseranlagen',
              description:
                'Wassergewinnungs-, Aufbereitungs- und Druckerhöhungsanlagen, Rohrleitungen, dezentrale Wassererwärmer, Sanitärobjekte',
            },
            {
              number: '413',
              label: 'Gasanlagen',
              description:
                'Gasanlagen für Wirtschaftswärme: Gaslagerungs- und Erzeugungsanlagen, Übergabestationen, Druckregelanlagen und Gasleitungen, soweit nicht zu den Kostengruppen 420 oder 470 gehörend',
            },
            {
              number: '419',
              label: 'Abwasser-, Wasser-, Gasanlagen, sonstiges',
              description: 'Installationsblöcke, Sanitärzellen',
            },
          ],
        },
        {
          number: '420',
          label: 'Wärmeversorgungsanlagen',
          description: '',
          phases: [
            {
              number: '421',
              label: 'Wärmeerzeugungsanlagen',
              description:
                'Brennstoffversorgung, Wärmeübergabestationen, Wärmeerzeugung auf der Grundlage von Brennstoffen oder unerschöpflichen Energiequellen einschließlich Schornsteinanschlüssen und zentraler Wassererwärmungsanlagen',
            },
            {
              number: '422',
              label: 'Wärmeverteilnetze',
              description:
                'Pumpen, Verteiler; Rohrleitungen für Raumheizflächen, raumlufttechnische Anlagen und sonstige Wärmeverbraucher',
            },
            {
              number: '423',
              label: 'Raumheizflächen',
              description: 'Heizkörper, Flächenheizsysteme',
            },
            {
              number: '429',
              label: 'Wärmeversorgungsanlagen, sonstiges',
              description:
                'Schornsteine, soweit nicht in anderen Kostengruppen erfasst',
            },
          ],
        },
        {
          number: '430',
          label: 'Lufttechnische Anlagen',
          description: 'Anlagen mit und ohne Lüftungsfunktion',
          phases: [
            {
              number: '431',
              label: 'Lüftungsanlagen',
              description:
                'Abluftanlagen, Zuluftanlagen, Zu- und Abluftanlagen ohne oder mit einer thermodynamischen Luftbehandlungsfunktion, mechanische Entrauchungsanlagen',
            },
            {
              number: '432',
              label: 'Teilklimaanlagen',
              description:
                'Anlagen mit zwei oder drei thermodynamischen Luftbehandlungsfunktionen',
            },
            {
              number: '433',
              label: 'Klimaanlagen',
              description:
                'Anlagen mit vier thermodynamischen Luftbehandlungsfunktionen',
            },
            {
              number: '434',
              label: 'Kälteanlagen',
              description:
                'Kälteanlagen für lufttechnische Anlagen: Kälteerzeugungs- und Rückkühlanlagen einschließlich Pumpen, Verteiler und Rohrleitungen',
            },
            {
              number: '439',
              label: 'Lufttechnische Anlagen, sonstiges',
              description:
                'Lüftungsdecken, Kühldecken, Abluftfenster; Installationsdoppelböden, soweit nicht in anderen Kostengruppen erfasst',
            },
          ],
        },
        {
          number: '440',
          label: 'Starkstromanlagen',
          description:
            'Einschließlich der Brandschutzdurchführungen, soweit nicht in anderen Kostengruppen erfasst',
          phases: [
            {
              number: '441',
              label: 'Hoch- und Mittelspannungsanlagen',
              description: 'Schaltanlagen, Transformatoren',
            },
            {
              number: '442',
              label: 'Eigenstromversorgungsanlagen',
              description:
                'Stromerzeugungsaggregate einschließlich Kühlung, Abgasanlagen, Brennstoffversorgung, zentraler Batterie- und unterbrechungsfreier Stromversorgungsanlagen, photovoltaischer Anlagen',
            },
            {
              number: '443',
              label: 'Niederspannungsschaltanlagen',
              description:
                'Niederspannungshauptverteiler, Blindstromkompensationsanlagen, Maximumüberwachungsanlagen',
            },
            {
              number: '444',
              label: 'Niederspannungsinstallationsanlagen',
              description:
                'Kabel, Leitungen, Unterverteiler, Verlegesysteme, Installationsgeräte',
            },
            {
              number: '445',
              label: 'Beleuchtungsanlagen',
              description: 'Ortsfeste Leuchten, Sicherheitsbeleuchtung',
            },
            {
              number: '446',
              label: 'Blitzschutz- und Erdungsanlagen',
              description:
                'Auffangeinrichtungen, Ableitungen, Erdungen, Potentialausgleich',
            },
            {
              number: '449',
              label: 'Starkstromanlagen, sonstiges',
              description: 'Frequenzumformer',
            },
          ],
        },
        {
          number: '450',
          label: 'Fernmelde- und informationstechnische Anlagen',
          description:
            'Die einzelnen Anlagen enthalten die zugehörigen Verteiler, Kabel, Leitungen.',
          phases: [
            {
              number: '451',
              label: 'Telekommunikationsanlagen',
              description: '',
            },
            {
              number: '452',
              label: 'Such- und Signalanlagen',
              description:
                'Personenrufanlagen, Lichtruf- und Klingelanlagen, Türsprech- und Türöffneranlagen',
            },
            {
              number: '453',
              label: 'Zeitdienstanlagen',
              description: 'Uhren- und Zeiterfassungsanlagen',
            },
            {
              number: '454',
              label: 'Elektroakustische Anlagen',
              description:
                'Beschallungsanlagen, Konferenz- und Dolmetscheranlagen, Gegen- und Wechselsprechanlagen',
            },
            {
              number: '455',
              label: 'Fernseh- und Antennenanlagen',
              description:
                'Fernsehanlagen, soweit nicht in den Such-, Melde-, Signal- und Gefahrenmeldeanlagen erfasst, einschließlich Sende- und Empfangsantennenanlagen, Umsetzer',
            },
            {
              number: '456',
              label: 'Gefahrenmelde- und Alarmanlagen',
              description:
                'Brand-, Überfall-, Einbruchmeldeanlagen, Wächterkontrollanlagen, Zugangskontroll- und Raumbeobachtungsanlagen',
            },
            {
              number: '457',
              label: 'Übertragungsnetze',
              description:
                'Netze zur Übertragung von Daten, Sprache, Text und Bild, soweit nicht in anderen Kostengruppen erfasst, Verlegesysteme, soweit nicht in KG 444 erfasst',
            },
            {
              number: '459',
              label: 'Fernmelde- und informationstechnische Anlagen, sonstiges',
              description: 'Fernwirkanlagen, Parkleitsysteme',
            },
          ],
        },
        {
          number: '460',
          label: 'Förderanlagen',
          description: '',
          phases: [
            {
              number: '461',
              label: 'Aufzugsanlagen',
              description: 'Personenaufzüge, Lastenaufzüge',
            },
            {
              number: '462',
              label: 'Fahrtreppen, Fahrsteige',
              description: '',
            },
            {
              number: '463',
              label: 'Befahranlagen',
              description: 'Fassadenaufzüge und andere Befahranlagen',
            },
            {
              number: '464',
              label: 'Transportanlagen',
              description:
                'Automatische Warentransportanlagen, Aktentransportanlagen, Rohrpostanlagen',
            },
            {
              number: '465',
              label: 'Krananlagen',
              description: 'Einschließlich Hebezeuge',
            },
            {
              number: '469',
              label: 'Förderanlagen, sonstiges',
              description: 'Hebebühnen',
            },
          ],
        },
        {
          number: '470',
          label: 'Nutzungsspezifische Anlagen',
          description:
            'Kosten der mit dem Bauwerk fest verbundenen Anlagen, die der besonderen Zweckbestimmung dienen, jedoch ohne die baukonstruktiven Einbauten (KG 370) Für die Abgrenzung gegenüber der KG 610 ist maßgebend, dass die nutzungsspezifischen Anlagen technische und planerische Maßnahmen erforderlich machen, z. B. Anfertigen von Werkplänen, Berechnungen, Anschließen von anderen technischen Anlagen.',
          phases: [
            {
              number: '471',
              label: 'Küchentechnische Anlagen',
              description:
                'Anlagen zur Speisen- und Getränkezubereitung, -ausgabe und -lagerung einschließlich zugehöriger Kälteanlagen',
            },
            {
              number: '472',
              label: 'Wäscherei- und Reinigungsanlagen',
              description:
                'Einschließlich zugehöriger Wasseraufbereitung, Desinfektions- und Sterilisationseinrichtungen',
            },
            {
              number: '473',
              label: 'Medienversorgungsanlagen',
              description:
                'Medizinische und technische Gase, Druckluft, Vakuum, Flüssigchemikalien, Lösungsmittel, vollentsalztes Wasser; einschließlich Lagerung, Erzeugungsanlagen, Übergabestationen, Druckregelanlagen, Leitungen und Entnahmearmaturen',
            },
            {
              number: '474',
              label: 'Medizin- und labortechnische Anlagen',
              description: 'Ortsfeste medizin- und labortechnische Anlagen,',
            },
            {
              number: '475',
              label: 'Feuerlöschanlagen',
              description:
                'Sprinkler- und Gaslöschanlagen, Löschwasserleitungen, Wandhydranten, Handfeuerlöscher',
            },
            {
              number: '476',
              label: 'Badetechnische Anlagen',
              description:
                'Aufbereitungsanlagen für Schwimmbeckenwasser, soweit nicht in KG 410 erfasst',
            },
            {
              number: '477',
              label: 'Prozesswärme-, kälte- und -luftanlagen',
              description:
                'Wärme-, Kälte- und Kühlwasserversorgungsanlagen für Industrie-, Gewerbe- und Sportanlagen, soweit nicht in anderen Kostengruppen erfasst; Farbnebelabscheideanlagen, Prozessfortluftsysteme, Absauganlagen',
            },
            {
              number: '478',
              label: 'Entsorgungsanlagen',
              description:
                'Abfall- und Medienentsorgungsanlagen, Staubsauganlagen',
            },
            {
              number: '479',
              label: 'Nutzungsspezifische Anlagen, sonstiges',
              description:
                'Bühnentechnische Anlagen, Tankstellen- und Waschanlagen',
            },
          ],
        },
        {
          number: '480',
          label: 'Gebäudeautomation',
          description: 'Kosten der anlageübergreifenden Automation',
          phases: [
            {
              number: '481',
              label: 'Automationssysteme',
              description:
                'Automationsstationen mit Bedien- und Beobachtungseinrichtungen, GA-Funktionen, Anwendungssoftware, Lizenzen, Sensoren und Aktoren, Schnittstellen zu Feldgeräten und anderen Automationseinrichtungen',
            },
            {
              number: '482',
              label: 'Schaltschränke',
              description:
                'Schaltschränke zur Aufnahme von Automationssystemen (KG 481) mit Leistungs-, Steuerungs- und Sicherungsbaugruppen einschließlich zugehöriger Kabel und Leitungen, Verlegesysteme soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '483',
              label: 'Management- und Bedieneinrichtungen',
              description:
                'Übergeordnete Einrichtungen für Gebäudeautomation und Gebäudemanagement mit Bedienstationen, Programmiereinrichtungen, Anwendungssoftware, Lizenzen, Servern, Schnittstellen zu Automationseinrichtungen und externen Einrichtungen',
            },
            {
              number: '484',
              label: 'Raumautomationssysteme',
              description:
                'Raumautomationsstationen mit Bedien- und Anzeigeeinrichtungen, Schnittstellen zu Feldgeräten und andere Automationseinrichtungen',
            },
            {
              number: '485',
              label: 'Übertragungsnetze',
              description:
                'Netze zur Datenübertragung, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '489',
              label: 'Gebäudeautomation, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '490',
          label: 'Sonstige Maßnahmen für technische Anlagen',
          description:
            'Technische Anlagen und übergreifende Maßnahmen im Zusammenhang mit technischen Anlagen, die nicht einzelnen Kostengruppen der technischen Anlagen zugeordnet werden können',
          phases: [
            {
              number: '491',
              label: 'Baustelleneinrichtung',
              description:
                'Einrichten, Vorhalten, Betreiben, Räumen der übergeordneten Baustelleneinrichtung für technische Anlagen, z. B. Material- und Geräteschuppen, Lager-, Wasch-, Toiletten- und Aufenthaltsräume, Bauwagen, Misch- und Transportanlagen, Energie- und Bauwasseranschlüsse, Baustraßen, Lager- und Arbeitsplätze, Verkehrssicherungen, Abdeckungen, Bauschilder, Bau- und Schutzzäune, Baubeleuchtung, Schuttbeseitigung',
            },
            {
              number: '492',
              label: 'Gerüste',
              description: 'Auf-, Um-, Abbauen, Vorhalten von Gerüsten',
            },
            {
              number: '493',
              label: 'Sicherungsmaßnahmen',
              description:
                'Sicherungsmaßnahmen an bestehenden Bauwerken, z. B. Unterfangungen, Abstützungen',
            },
            {
              number: '494',
              label: 'Abbruchmaßnahmen',
              description:
                'Abbruch- und Demontagearbeiten einschließlich Zwischenlagern wieder verwendbarer Teile, Abfuhr des Abbruchmaterials, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '495',
              label: 'Instandsetzungen',
              description:
                'Maßnahmen zur Wiederherstellung des zum bestimmungsgemäßen Gebrauch geeigneten Zustandes, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '496',
              label: 'Materialentsorgung',
              description:
                'Entsorgung von Materialien und Stoffen, die bei dem Abbruch, bei der Demontage und bei dem Ausbau von Anlagenteilen oder bei der Erstellung einer Bauleistung anfallen zum Zweck des Recyclings oder der Deponierung',
            },
            {
              number: '497',
              label: 'Zusätzliche Maßnahmen',
              description:
                'Zusätzliche Maßnahmen bei der Erstellung von technischen Anlagen z. B. Schutz von Personen, Sachen; Reinigung vor Inbetriebnahme; Maßnahmen aufgrund von Forderungen des Wasser-, Landschafts-, Lärm- und Erschütterungsschutzes während der Bauzeit; Schlechtwetter und Winterbauschutz, Erwärmung der technischen Anlagen, Schneeräumung,',
            },
            {
              number: '498',
              label: 'Provisorische technische Anlagen',
              description:
                'Kosten für die Erstellung, Beseitigung provisorischer technischer Anlagen, Anpassung der technischen Anlagen bis zur Inbetriebnahme der endgültigen technischen Anlagen',
            },

            {
              number: '499',
              label: 'Sonstige Maßnahmen für technische Anlagen, sonstiges',
              description: '',
            },
          ],
        },
      ],
    },

    {
      number: '500',
      label: 'Außenanlagen',
      description: '',
      phases: [
        {
          number: '510',
          label: 'Geländeflächen',
          description: '',
          phases: [
            {
              number: '511',
              label: 'Oberbodenarbeiten',
              description: 'Oberbodenabtrag und -sicherung',
            },
            {
              number: '512',
              label: 'Bodenarbeiten',
              description: 'Bodenabtrag und -auftrag',
            },
            {
              number: '519',
              label: 'Geländeflächen, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '520',
          label: 'Befestigte Flächen',
          description: '',
          phases: [
            {
              number: '521',
              label: 'Wege',
              description: 'Befestigte Fläche für den Fuß- und Radfahrverkehr',
            },
            {
              number: '522',
              label: 'Straßen',
              description:
                'Flächen für den Leicht- und Schwerverkehr; Fußgängerzonen mit Anlieferungsverkehr',
            },
            {
              number: '523',
              label: 'Plätze, Höfe',
              description: 'Gestaltete Platzflächen, Innenhöfe',
            },
            {
              number: '524',
              label: 'Stellplätze',
              description: 'Flächen für den ruhenden Verkehr',
            },
            {
              number: '525',
              label: 'Sportplatzflächen',
              description: 'Sportrasenflächen, Kunststoffflächen',
            },
            { number: '526', label: 'Spielplatzflächen', description: '' },
            { number: '527', label: 'Gleisanlagen', description: '' },
            {
              number: '529',
              label: 'Befestigte Flächen, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '530',
          label: 'Baukonstruktionen in Außenanlagen',
          description: '',
          phases: [
            {
              number: '531',
              label: 'Einfriedungen',
              description: 'Zäune, Mauern, Türen, Tore, Schrankenanlagen',
            },
            {
              number: '532',
              label: 'Schutzkonstruktionen',
              description: 'Lärmschutzwände, Sichtschutzwände, Schutzgitter',
            },
            {
              number: '533',
              label: 'Mauern, Wände',
              description: 'Stütz-, Schwergewichtsmauern',
            },
            {
              number: '534',
              label: 'Rampen, Treppen, Tribünen ',
              description:
                'Kinderwagen- und Behindertenrampen, Block- und Stellstufen, Zuschauertribünen von Sportplätzen',
            },
            {
              number: '535',
              label: 'Überdachungen',
              description: 'Wetterschutz, Unterstände; Pergolen',
            },
            {
              number: '536',
              label: 'Brücken, Stege',
              description: 'Holz- und Stahlkonstruktionen',
            },
            {
              number: '537',
              label: 'Kanal- und Schachtbauanlagen',
              description:
                'Bauliche Anlagen für Medien- oder Verkehrserschließung',
            },
            {
              number: '538',
              label: 'Wasserbauliche Anlagen',
              description: 'Brunnen, Wasserbecken,',
            },
            {
              number: '539',
              label: 'Baukonstruktionen in Außensanlagen, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '540',
          label: 'Technische Anlagen in Außenanlagen',
          description:
            'Kosten der technischen Anlagen auf dem Grundstück einschließlich der Ver- und Entsorgung des Bauwerks',
          phases: [
            {
              number: '541',
              label: 'Abwasseranlagen',
              description:
                'Kläranlagen, Oberflächen- und Bauwerksentwässerungsanlagen, Sammelgruben, Abscheider, Hebeanlagen',
            },
            {
              number: '542',
              label: 'Wasseranlagen',
              description:
                'Wassergewinnungsanlagen, Wasserversorgungsnetze, Hydrantenanlagen, Druckerhöhungs- und Beregnungsanlagen',
            },
            {
              number: '543',
              label: 'Gasanlagen',
              description: 'Gasversorgungsnetze, Flüssiggasanlagen',
            },
            {
              number: '544',
              label: 'Wärmeversorgungsanlagen',
              description:
                'Wärmeerzeugungsanlagen, Wärmeversorgungsnetze, Freiflächen- und Rampenheizungen',
            },
            {
              number: '545',
              label: 'Lufttechnische Anlagen',
              description:
                'Bauteile von lufttechnischen Anlagen, z. B. Außenluftansaugung, Fortluftausblas, Erdwärmetauscher, Kälteversorgung',
            },
            {
              number: '546',
              label: 'Starkstromanlagen',
              description:
                'Stromversorgungsnetze, Freilufttrafostationen, Eigenstromerzeugungsanlagen, Außenbeleuchtungs- und Flutlichtanlagen einschließlich Maste und Befestigung',
            },
            {
              number: '547',
              label: 'Fernmelde- und informationstechnische Anlagen',
              description:
                'Leitungsnetze, Beschallungs-, Zeitdienst- und Verkehrssignalanlagen, elektronische Anzeigetafeln, Objektsicherungsanlagen, Parkleitsysteme',
            },
            {
              number: '548',
              label: 'Nutzungsspezifische Anlagen',
              description:
                'Medienversorgungsanlagen, Tankstellenanlagen, badetechnische Anlagen, leitungsgebundene Abfallentsorgung',
            },
            {
              number: '549',
              label: 'Technische Anlagen in Außenanlagen, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '550',
          label: 'Einbauten in Außenanlagen',
          description: '',
          phases: [
            {
              number: '551',
              label: 'Allgemeine Einbauten',
              description:
                'Wirtschaftsgegenstände, z. B. Möbel, Fahrradständer, Schilder, Pflanzbehälter, Abfallbehälter, Fahnenmaste',
            },
            {
              number: '552',
              label: 'Besondere Einbauten',
              description: 'Einbauten für Sport- und Spielanlagen, Tiergehege',
            },
            {
              number: '559',
              label: 'Einbauten in Außenanlagen, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '560',
          label: 'Wasserflächen',
          description: 'Naturnahe Wasserflächen',
          phases: [
            {
              number: '561',
              label: 'Abdichtungen',
              description:
                'Einschließlich Schutzschichten, Bodensubstrat und Uferausbildung',
            },
            {
              number: '562',
              label: 'Bepflanzungen',
              description: '',
            },
            {
              number: '569',
              label: 'Wasserflächen, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '570',
          label: 'Pflanz- und Saatflächen',
          description: '',
          phases: [
            {
              number: '571',
              label: 'Oberbodenarbeiten',
              description: 'Oberbodenauftrag, Oberbodenlockerung',
            },
            {
              number: '572',
              label: 'Vegetationstechnische Bodenbearbeitung',
              description: 'Bodenverbesserung, z. B. Düngung, Bodenhilfsstoffe',
            },
            {
              number: '573',
              label: 'Sicherungsbauweisen',
              description: 'Vegetationsstücke, Geotextilien, Flechtwerk',
            },
            {
              number: '574',
              label: 'Pflanzen',
              description: 'Einschließlich Fertigstellungspflege',
            },
            {
              number: '575',
              label: 'Rasen und Ansaaten',
              description:
                'Einschließlich Fertigstellungspflege, ohne Sportrasenflächen (siehe KG 525',
            },
            {
              number: '576',
              label: 'Begrünung unterbauter Flächen',
              description:
                'Auf Tiefgaragen, einschließlich Wurzelschutz- und Fertigstellungspflege',
            },
            {
              number: '579',
              label: 'Pflanz- und Saatflächen, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '590',
          label: 'Sonstige Außenanlagen',
          description:
            'Außenanlagen und übergreifende Maßnahmen im Zusammenhang mit den Außenanlagen, die nicht einzelnen Kostengruppen der Außenanlagen zugeordnet werden können',
          phases: [
            {
              number: '591',
              label: 'Baustelleneinrichtung',
              description:
                'Einrichten, Vorhalten, Betreiben, Räumen der übergeordneten Baustelleneinrichtung für Außenanlagen, z. B. Material- und Geräteschuppen, Lager-, Wasch-, Toiletten- und Aufenthaltsräume, Bauwagen, Misch- und Transportanlagen, Energie- und Bauwasseranschlüsse, Baustraßen, Lager- und Arbeitsplätze, Verkehrssicherungen, Abdeckungen, Bauschilder, Bau- und Schutzzäune, Baubeleuchtung, Schuttbeseitigung',
            },
            {
              number: '592',
              label: 'Gerüste',
              description: 'Auf-, Um-, Abbauen, Vorhalten von Gerüsten',
            },
            {
              number: '593',
              label: 'Sicherungsmaßnahmen',
              description:
                'Sicherungsmaßnahmen an bestehenden baulichen Anlagen, z. B. Unterfangungen, Abstützungen',
            },
            {
              number: '594',
              label: 'Abbruchmaßnahmen',
              description:
                'Abbruch- und Demontagearbeiten einschließlich Zwischenlagern wiederverwendbarer Teile, Abfuhr des Abbruchmaterials, soweit nicht in anderen Kostengruppen erfasst',
            },

            {
              number: '595',
              label: 'Instandsetzungen',
              description:
                'Maßnahmen zur Wiederherstellung des zum bestimmungsgemäßen Gebrauch geeigneten Zustandes, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '596',
              label: 'Materialentsorgung',
              description:
                'Entsorgung von Materialien und Stoffen, die bei dem Abbruch, bei der Demontage und bei dem Ausbau von Außenanlagen oder bei der Erstellung einer Bauleistung anfallen zum Zweck des Recyclings oder der Deponierung',
            },
            {
              number: '597',
              label: 'Zusätzliche Maßnahmen',
              description:
                'Zusätzliche Maßnahmen bei der Erstellung von Außenanlagen z. B. Schutz von Personen, Sachen; Reinigung vor Inbetriebnahme; Maßnahmen aufgrund von Forderungen des Wasser-, Landschafts-, Lärm- und Erschütterungsschutzes während der Bauzeit; Schlechtwetter und Winterbauschutz, Erwärmung, Schneeräumung',
            },
            {
              number: '598',
              label: 'Provisorische Außenanlagen',
              description:
                'Kosten für die Erstellung, Beseitigung provisorischer Außenanlagen, Anpassung der Außenanlagen bis zur Inbetriebnahme der endgültigen Außenanlagen',
            },
            {
              number: '599',
              label: 'Sonstige Maßnahmen für Außenanlagen, sonstiges',
              description: '',
            },
          ],
        },
      ],
    },

    {
      number: '600',
      label: 'Ausstattung und Kunstwerke',
      description:
        'Kosten für alle beweglichen oder ohne besondere Maßnahmen zu befestigenden Sachen, die zur Ingebrauchnahme, zur allgemeinen Benutzung oder zur künstlerischen Gestaltung des Bauwerks und der Außenanlagen erforderlich sind (siehe Anmerkungen zu den KG 370 und 470',
      phases: [
        {
          number: '610',
          label: 'Ausstattung',
          description: '',
          phases: [
            {
              number: '611',
              label: 'Allgemeine Ausstattung',
              description:
                'Möbel und Geräte, z. B. Sitz- und Liegemöbel, Schränke, Regale, Tische; Textilien, z. B. Vorhänge, Wandbehänge, lose Teppiche, Wäsche; Hauswirtschafts-, Garten- und Reinigungsgeräte',
            },
            {
              number: '612',
              label: 'Besondere Ausstattung',
              description:
                'Ausstattungsgegenstände, die der besonderen Zweckbestimmung eines Objekts dienen wie z. B. wissenschaftliche, medizinische, technische Geräte',
            },
            {
              number: '619',
              label: 'Ausstattung, sonstiges',
              description:
                'Schilder, Wegweiser, Orientierungstafeln, Werbeanlagen',
            },
          ],
        },
        {
          number: '620',
          label: 'Kunstwerke',
          description: '',
          phases: [
            {
              number: '621',
              label: 'Kunstobjekte',
              description:
                'Kunstwerke zur künstlerischen Ausstattung des Bauwerks und der Außenanlagen einschließlich Tragkonstruktionen, z. B. Skulpturen, Objekte, Gemälde, Möbel, Antiquitäten, Altäre, Taufbecken',
            },
            {
              number: '622',
              label: 'Künstlerisch gestaltete Bauteile des Bauwerks',
              description:
                'Kosten für die künstlerische Gestaltung, z. B. Malereien, Reliefs, Mosaiken, Glas-, Schmiede-, Steinmetzarbeiten',
            },
            {
              number: '623',
              label: 'Künstlerisch gestaltete Bauteile der Außenanlagen',
              description:
                'Kosten für die künstlerische Gestaltung, z. B. Malereien, Reliefs, Mosaiken, Glas-, Schmiede-, Steinmetzarbeiten',
            },
            {
              number: '629',
              label: 'Kunstwerke, sonstiges',
              description: '',
            },
          ],
        },
      ],
    },

    {
      number: '700',
      label: 'Baunebenkosten',
      description: '',
      phases: [
        {
          number: '710',
          label: 'Bauherrenaufgaben',
          description: '',
          phases: [
            {
              number: '711',
              label: 'Projektleitung',
              description:
                'Kosten zum Zwecke der Zielvorgabe, der Überwachung und Vertretung der Bauherreninteressen',
            },
            {
              number: '712',
              label: 'Bedarfsplanung',
              description:
                'Kosten für Bedarfs-, Betriebs- und Organisationsplanung, z. B. zur betrieblichen Organisation, zur Arbeitsplatzgestaltung, zur Erstellung von Raum- und Funktionsprogrammen, zur betrieblichen Ablaufplanung und zur Inbetriebnahme',
            },
            {
              number: '713',
              label: 'Projektsteuerung',
              description:
                'Kosten für Projektsteuerungsleistungen sowie für andere Leistungen, die sich mit der übergeordneten Steuerung und Kontrolle von Projektorganisation, Terminen, Kosten, Qualitäten und Quantitäten befassen',
            },
            {
              number: '719',
              label: 'Bauherrenaufgaben, sonstiges',
              description: 'Baubetreuung, Rechtsberatung, Steuerberatung',
            },
          ],
        },
        {
          number: '720',
          label: 'Vorbereitung der Objektplanung',
          description: '',
          phases: [
            {
              number: '721',
              label: 'Untersuchungen',
              description:
                'Standortanalysen, Baugrundgutachten, Gutachten für die Verkehrsanbindung, Bestandsanalysen, z. B. Untersuchungen zum Gebäudebestand bei Umbau- und Modernisierungsmaßnahmen, Umweltverträglichkeitsprüfungen',
            },
            {
              number: '722',
              label: 'Wertermittlungen',
              description:
                'Gutachten zur Ermittlung von Gebäudewerten, soweit nicht KG 126 erfasst',
            },
            {
              number: '723',
              label: 'Städtebauliche Leistungen',
              description: 'vorbereitende Bebauungsstudien',
            },
            {
              number: '724',
              label: ' Landschaftsplanerische Leistungen',
              description: 'vorbereitende Grünplanstudien',
            },
            {
              number: '725',
              label: 'Wettbewerbe',
              description:
                'Kosten für Ideenwettbewerbe und Realisierungswettbewerbe',
            },
            {
              number: '729',
              label: 'Vorbereitung der Objektplanung, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '730',
          label: 'Architekten- und Ingenieurleistungen',
          description: 'Kosten für die Planung und Überwachung der Ausführung',
          phases: [
            {
              number: '731',
              label: 'Gebäudeplanung',
              description: '',
            },
            { number: '732', label: 'Freianlagenplanung', description: '' },
            {
              number: '733',
              label: 'Planung der raumbildenden Ausbauten',
              description: '',
            },
            {
              number: '734',
              label: 'Planung der Ingenieurbauwerke und Verkehrsanlagen',
              description: '',
            },
            {
              number: '735',
              label: 'Tragwerksplanung',
              description: '',
            },
            {
              number: '736',
              label: 'Planung der technischen Ausrüstung',
              description: '',
            },
            {
              number: '739',
              label: 'Architekten- und Ingenieurleistungen, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '740',
          label: 'Gutachten und Beratung',
          description: '',
          phases: [
            { number: '741', label: 'Thermische Bauphysik', description: '' },
            {
              number: '742',
              label: 'Schallschutz und Raumakustik',
              description: '',
            },
            {
              number: '743',
              label: 'Bodenmechanik, Erd- und Grundbau',
              description: '',
            },
            {
              number: '744',
              label: 'Vermessung',
              description:
                'Vermessungstechnische Leistungen mit Ausnahme von Leistungen, die aufgrund landesrechtlicher Vorschriften für Zwecke der Landvermessung und des Liegenschaftskatasters durchgeführt werden (siehe Kostengruppe 771)',
            },
            {
              number: '745',
              label: 'Lichttechnik, Tageslichttechnik',
              description: '',
            },
            { number: '746', label: 'Brandschutz', description: '' },
            {
              number: '747',
              label: 'Sicherheits- und Gesundheitsschutz',
              description: '',
            },
            {
              number: '748',
              label: 'Umweltschutz, Altlasten',
              description: '',
            },
            {
              number: '749',
              label: 'Gutachten und Beratung, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '750',
          label: 'Künstlerische Leistungen',
          description: '',
          phases: [
            {
              number: '751',
              label: 'Kunstwettbewerbe',
              description:
                'Kosten für die Durchführung von Wettbewerben zur Erarbeitung eines Konzepts für Kunstwerke oder künstlerisch gestaltete Bauteile',
            },
            {
              number: '752',
              label: 'Honorare',
              description:
                'Kosten für die geistig-schöpferische Leistung für Kunstwerke oder künstlerisch gestaltete Bauteile, soweit nicht in der Kostengruppe 620 enthalten',
            },
            {
              number: '759',
              label: 'Künstlerische Leistungen, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '760',
          label: 'Finanzierungskosten',
          description:
            'Alle im Zusammenhang mit der Finanzierung des Projektes anfallenden Kosten bis zum Zeitpunkt der Fertigstellung und der Übergabe zur Nutzung',
          phases: [
            {
              number: '761',
              label: 'Finanzierungsbeschaffung',
              description: '',
            },
            {
              number: '762',
              label: 'Fremdkapitalzinsen',
              description: '',
            },
            {
              number: '763',
              label: 'Eigenkapitalzinsen',
              description: '',
            },
            {
              number: '769',
              label: 'Finanzierungskosten, sonstiges',
              description: '',
            },
          ],
        },
        {
          number: '770',
          label: 'Allgemeine Baunebenkosten',
          description: '',
          phases: [
            {
              number: '771',
              label: 'Prüfung, Genehmigungen, Abnahmen',
              description:
                'Kosten im Zusammenhang mit Prüfungen, Genehmigungen und Abnahmen, z. B. Prüfung der Tragwerksplanung, Vermessungsgebühren für das Liegenschaftskataster',
            },
            {
              number: '772',
              label: 'Bewirtschaftungskosten',
              description:
                'Baustellenbewachung, Nutzungsentschädigungen während der Bauzeit; Gestellung des Baustellenbüros für Planer und Bauherrn sowie dessen Beheizung, Beleuchtung und Reinigung',
            },
            {
              number: '773',
              label: 'Bemusterungskosten',
              description:
                'Modellversuche, Musterstücke, Eignungsversuche, Eignungsmessungen',
            },
            {
              number: '774',
              label: 'Betriebskosten nach der Abnahme',
              description:
                'Kosten für den vorläufigen Betrieb insbesondere der technischen Anlagen nach der Abnahme bis zur Inbetriebnahme',
            },
            {
              number: '775',
              label: 'Versicherungen',
              description: 'Haftpflicht- und Bauwesenversicherung',
            },
            {
              number: '779',
              label: 'Allgemeine Baunebenkosten, sonstiges',
              description:
                'Kosten für Vervielfältigung und Dokumentation, Post- und Fernsprechgebühren, Kosten für Baufeiern, z. B. Grundsteinlegung, Richtfest',
            },
          ],
        },
        {
          number: '790',
          label: 'Sonstige Baunebenkosten',
          description: '',
        },
      ],
    },
  ],
};
